<template>
	<button
		v-if="remoteVersion"
		type="button"
		class="version-update-pill"
		:title="t('layout.versionUpdate.tooltip', { current: currentVersion, remote: remoteVersion })"
		@click="hardReload">
		<Info :size="14" />
		<span class="version-update-pill__text">
			{{ t('layout.versionUpdate.textBefore') }}
			<span class="font-bold underline">{{ t('layout.versionUpdate.textLink') }}</span>{{ t('layout.versionUpdate.textAfter') }}
		</span>
	</button>
</template>

<script setup lang="ts">
	import { Info } from 'lucide-vue-next'
	import { useI18n } from 'vue-i18n'
	import { currentVersion, remoteVersion, hardReload } from '@/libs/versionChecker'
	import { _translations } from './_translations'

	const { t } = useI18n(_translations)
</script>

<style scoped>
	@reference '@/styles/tailwind.css';

	.version-update-pill {
		@apply bg-error text-error-content inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-normal transition-colors hover:bg-error/90;
	}

	.version-update-pill__text {
		@apply leading-none;
	}
</style>
